import { useQuery } from '@tanstack/react-query'
import professionalProfileApi from "../api/professionalProfile";

const useFieldChoices = () => {
    const {data: fieldChoices, error: fieldChoicesError} = useQuery({
        queryKey: ['field-choices'],
        queryFn: async() => {
            const res = await professionalProfileApi.getFieldChoices()
            return res.data
        }
    })

    return { fieldChoices, fieldChoicesError }
}

export default useFieldChoices;